/* Thème « Éclat » 2.0 — scripts */
(function () {
  'use strict';

  var html = document.documentElement;
  window.themeReady = true;
  var routes = window.themeRoutes || { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', predictiveSearch: '/search/suggest' };
  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var canHover = !!(window.matchMedia && window.matchMedia('(hover: hover)').matches);

  /* ---------- Outils ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function parseHTML(text) { return new DOMParser().parseFromString(text, 'text/html'); }
  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }
  function withSection(url, id) { var u = new URL(url, window.location.origin); u.searchParams.set('section_id', id); return u.pathname + u.search; }
  function once(el, key) { if (!el || el.dataset[key]) return false; el.dataset[key] = '1'; return true; }

  var toastTimer;
  function toast(msg) {
    var t = $('[data-toast]'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    requestAnimationFrame(function () { t.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-visible'); setTimeout(function () { t.hidden = true; }, 300); }, 2600);
  }

  /* ---------- Apparition au défilement ---------- */
  var observer = null;
  if (html.classList.contains('anim') && 'IntersectionObserver' in window) {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); observer.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
  }
  function reveal(root) {
    $$('.reveal:not(.is-in)', root).forEach(function (el) {
      if (observer) observer.observe(el); else el.classList.add('is-in');
    });
  }

  /* ---------- Fenêtres (dialog) ---------- */
  var Dialog = {
    open: function (d) {
      if (!d || typeof d.showModal !== 'function') return false;
      if (!d.open) { d.classList.remove('is-closing'); d.showModal(); }
      html.classList.add('dialog-open');
      return true;
    },
    close: function (d) {
      if (!d || !d.open) return;
      if (reduceMotion) { d.close(); return; }
      d.classList.add('is-closing');
      setTimeout(function () { d.classList.remove('is-closing'); if (d.open) d.close(); }, 230);
    },
    closeAll: function (except) {
      $$('dialog[open]').forEach(function (d) { if (d !== except) d.close(); });
    }
  };

  function initDialogs() {
    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-dialog-open]');
      if (opener) {
        var target = document.getElementById(opener.getAttribute('data-dialog-open'));
        if (target) {
          e.preventDefault();
          Dialog.closeAll(target);
          Dialog.open(target);
          if (target.id === 'search-modal') {
            var input = $('[data-search-input]', target);
            if (input) setTimeout(function () { input.focus(); }, 60);
          }
        }
        return;
      }
      var closer = e.target.closest('[data-dialog-close]');
      if (closer) { Dialog.close(closer.closest('dialog')); return; }
      if (e.target.tagName === 'DIALOG' && e.target.open) {
        var r = e.target.getBoundingClientRect();
        var inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
        if (!inside || e.target.classList.contains('lightbox')) Dialog.close(e.target);
      }
    });
    $$('dialog').forEach(bindDialog);
  }
  function bindDialog(d) {
    if (!once(d, 'dialogBound')) return;
    d.addEventListener('cancel', function (e) { e.preventDefault(); Dialog.close(d); });
    d.addEventListener('close', function () {
      if (!$('dialog[open]')) html.classList.remove('dialog-open');
    });
  }

  /* ---------- En-tête ---------- */
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;
    var wrap = header.closest('.shopify-section') || header.parentElement;
    var onScroll = function () { wrap.classList.toggle('is-solid', window.scrollY > 24); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    var dropdowns = $$('[data-dropdown]', header);
    function closeAll(except) { dropdowns.forEach(function (d) { if (d !== except) d.open = false; }); }
    dropdowns.forEach(function (d) {
      var item = d.closest('[data-nav-item]');
      var leaveTimer;
      if (canHover && item) {
        item.addEventListener('mouseenter', function () { clearTimeout(leaveTimer); closeAll(d); d.open = true; });
        item.addEventListener('mouseleave', function () { leaveTimer = setTimeout(function () { d.open = false; }, 160); });
      }
      d.addEventListener('toggle', function () { if (d.open) closeAll(d); });
    });
    document.addEventListener('click', function (e) {
      dropdowns.forEach(function (d) { if (d.open && !d.contains(e.target)) d.open = false; });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') dropdowns.forEach(function (d) {
        if (d.open) { d.open = false; var s = $('summary', d); if (s) s.focus(); }
      });
    });
  }

  /* ---------- Bandeau d'annonce ---------- */
  function initAnnouncement(root) {
    $$('[data-announcement]', root).forEach(function (bar) {
      if (!once(bar, 'init')) return;
      var slides = $$('[data-slide]', bar);
      if (slides.length < 2) return;
      var i = 0, timer = null, delay = (parseInt(bar.dataset.speed, 10) || 5) * 1000;
      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) {
          var on = k === i;
          s.classList.toggle('is-active', on);
          s.setAttribute('aria-hidden', on ? 'false' : 'true');
          if (on) s.removeAttribute('inert'); else s.setAttribute('inert', '');
        });
      }
      function play() { if (reduceMotion) return; stop(); timer = setInterval(function () { show(i + 1); }, delay); }
      function stop() { clearInterval(timer); }
      var prev = $('[data-ann-prev]', bar), next = $('[data-ann-next]', bar);
      if (prev) prev.addEventListener('click', function () { show(i - 1); play(); });
      if (next) next.addEventListener('click', function () { show(i + 1); play(); });
      bar.addEventListener('mouseenter', stop);
      bar.addEventListener('mouseleave', play);
      bar.addEventListener('focusin', stop);
      play();
    });
  }

  /* ---------- Panier ---------- */
  var Cart = {
    drawer: function () { return $('[data-cart-drawer]'); },
    updateCount: function (n) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = n; el.hidden = n === 0;
        el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump');
      });
    },
    render: function (markup) {
      var d = Cart.drawer();
      if (!d || !markup) return;
      var fresh = parseHTML(markup).querySelector('[data-cart-drawer-inner]');
      var current = $('[data-cart-drawer-inner]', d);
      if (fresh && current) current.replaceWith(fresh);
      var countEl = $('[data-cart-count-value]', d);
      if (countEl) Cart.updateCount(parseInt(countEl.textContent, 10) || 0);
    },
    refresh: function () {
      return fetch(routes.root + (routes.root.indexOf('?') > -1 ? '&' : '?') + 'sections=cart-drawer', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (data) { Cart.render(data['cart-drawer']); });
    },
    open: function () {
      var d = Cart.drawer();
      if (!d) return false;
      Dialog.closeAll(d);
      return Dialog.open(d);
    },
    change: function (line, qty) {
      var d = Cart.drawer();
      var inner = d && $('[data-cart-drawer-inner]', d);
      if (inner) inner.setAttribute('aria-busy', 'true');
      return fetch(routes.cartChange, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: parseInt(line, 10), quantity: Math.max(0, parseInt(qty, 10) || 0), sections: 'cart-drawer', sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.sections && data.sections['cart-drawer']) Cart.render(data.sections['cart-drawer']);
          else return Cart.refresh();
        })
        .catch(function () { window.location.href = routes.cart; });
    }
  };

  function initCart() {
    var d = Cart.drawer();
    if (d) {
      d.addEventListener('click', function (e) {
        var change = e.target.closest('[data-line][data-qty]');
        if (change) { e.preventDefault(); Cart.change(change.getAttribute('data-line'), change.getAttribute('data-qty')); }
      });
      $$('[data-cart-toggle]').forEach(function (link) {
        link.addEventListener('click', function (e) { if (Cart.open()) e.preventDefault(); });
      });
    }

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.classList || !form.classList.contains('js-ajax-cart')) return;
      if (!Cart.drawer() || !window.fetch) return;
      if (e.submitter && e.submitter.name === 'checkout') return;
      e.preventDefault();

      var buttons = $$('[type="submit"]', form).concat(form.id ? $$('button[form="' + form.id + '"]') : []);
      buttons.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
      var errorEl = $('[data-form-error]', form);
      if (errorEl) errorEl.hidden = true;

      var body = new FormData(form);
      body.append('sections', 'cart-drawer');
      body.append('sections_url', window.location.pathname);

      fetch(routes.cartAdd, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: body
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok || res.data.status) {
            var msg = (res.data && (res.data.description || res.data.message)) || 'Impossible d’ajouter ce bijou au panier.';
            if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; } else { toast(msg); }
            return;
          }
          var done = function () { Cart.open(); };
          if (res.data.sections && res.data.sections['cart-drawer']) { Cart.render(res.data.sections['cart-drawer']); done(); }
          else Cart.refresh().then(done);
        })
        .catch(function () { form.submit(); })
        .finally(function () { buttons.forEach(function (b) { b.removeAttribute('aria-busy'); }); });
    });
  }

  /* ---------- Aperçu rapide ---------- */
  function initQuickView() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quick-view]');
      if (!btn) return;
      var url = btn.getAttribute('data-quick-view');
      var d = $('#quick-view');
      if (!d || !window.fetch) return;
      e.preventDefault();
      var body = $('[data-quick-view-body]', d);
      body.innerHTML = '<div class="modal__loading"><span class="spinner"></span></div>';
      Dialog.closeAll(d);
      Dialog.open(d);
      fetch(withSection(url, 'quick-view'), { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(); return r.text(); })
        .then(function (text) {
          var section = parseHTML(text).querySelector('[data-product]');
          if (!section) throw new Error();
          body.innerHTML = '';
          body.appendChild(section);
          initProduct(section);
          if (canHover) { var first = $('[data-option-input]:checked, [data-add-button]', section); if (first) first.focus({ preventScroll: true }); }
        })
        .catch(function () { window.location.href = url; });
    });
  }

  /* ---------- Recherche instantanée ---------- */
  function initSearch() {
    var d = $('#search-modal');
    if (!d) return;
    var input = $('[data-search-input]', d), out = $('[data-predictive-results]', d);
    if (!input || !out) return;
    var last = '';
    var run = debounce(function () {
      var q = input.value.trim();
      if (q === last) return;
      last = q;
      if (q.length < 2) { out.innerHTML = ''; return; }
      var url = routes.predictiveSearch + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=8&resources[options][prefix]=last&section_id=predictive-search';
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error(); return r.text(); })
        .then(function (text) {
          if (input.value.trim() !== q) return;
          var res = parseHTML(text).querySelector('[data-predictive]');
          out.innerHTML = res ? res.outerHTML : '';
        })
        .catch(function () { out.innerHTML = ''; });
    }, 220);
    input.addEventListener('input', run);
  }

  /* ---------- Zoom photo ---------- */
  var Lightbox = {
    srcs: [], i: 0,
    el: function () { return $('#lightbox'); },
    open: function (srcs, i) {
      var d = Lightbox.el(); if (!d) return;
      Lightbox.srcs = srcs; Lightbox.show(i);
      Dialog.open(d);
    },
    show: function (n) {
      var d = Lightbox.el(); var img = $('[data-lightbox-img]', d);
      var count = $('[data-lightbox-count]', d);
      Lightbox.i = (n + Lightbox.srcs.length) % Lightbox.srcs.length;
      img.classList.remove('is-zoomed');
      img.src = Lightbox.srcs[Lightbox.i];
      if (count) count.textContent = Lightbox.srcs.length > 1 ? (Lightbox.i + 1) + ' / ' + Lightbox.srcs.length : '';
      $$('.lightbox__nav', d).forEach(function (b) { b.hidden = Lightbox.srcs.length < 2; });
    }
  };
  function initLightbox() {
    var d = Lightbox.el(); if (!d) return;
    var img = $('[data-lightbox-img]', d), stage = $('[data-lightbox-stage]', d);
    $('[data-lightbox-prev]', d).addEventListener('click', function () { Lightbox.show(Lightbox.i - 1); });
    $('[data-lightbox-next]', d).addEventListener('click', function () { Lightbox.show(Lightbox.i + 1); });
    img.addEventListener('click', function (e) {
      e.stopPropagation();
      if (!canHover) return;
      img.classList.toggle('is-zoomed');
      var r = img.getBoundingClientRect();
      img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
    });
    img.addEventListener('mousemove', function (e) {
      if (!img.classList.contains('is-zoomed')) return;
      var r = img.getBoundingClientRect();
      img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
    });
    stage.addEventListener('click', function (e) { if (e.target === stage) Dialog.close(d); });
    d.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') Lightbox.show(Lightbox.i + 1);
      if (e.key === 'ArrowLeft') Lightbox.show(Lightbox.i - 1);
    });
    var sx = null;
    stage.addEventListener('touchstart', function (e) { sx = e.touches.length === 1 ? e.touches[0].clientX : null; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 50) Lightbox.show(Lightbox.i + (dx < 0 ? 1 : -1));
      sx = null;
    });
  }

  /* ---------- Galerie produit ---------- */
  function initGallery(gallery) {
    var slides = $$('[data-media-id]', gallery);
    var thumbs = $$('[data-thumb]', gallery);
    var counter = $('[data-gallery-count]', gallery);
    function current() { for (var k = 0; k < slides.length; k++) if (!slides[k].hidden) return k; return 0; }
    function show(id) {
      id = String(id);
      var idx = -1;
      slides.forEach(function (s, k) { if (s.getAttribute('data-media-id') === id) idx = k; });
      if (idx < 0) return;
      slides.forEach(function (s, k) { s.hidden = k !== idx; });
      thumbs.forEach(function (t) {
        var on = t.getAttribute('data-thumb') === id;
        t.setAttribute('aria-current', on ? 'true' : 'false');
        if (on) {
          var box = t.parentElement;
          if (box.scrollHeight > box.clientHeight + 4) box.scrollTo({ top: t.offsetTop - box.clientHeight / 2 + t.clientHeight / 2, behavior: 'smooth' });
          else if (box.scrollWidth > box.clientWidth + 4) box.scrollTo({ left: t.offsetLeft - box.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
        }
      });
      if (counter) counter.textContent = (idx + 1) + ' / ' + slides.length;
    }
    function step(dir) { if (slides.length) show(slides[(current() + dir + slides.length) % slides.length].getAttribute('data-media-id')); }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t.getAttribute('data-thumb')); }); });
    var prev = $('[data-gallery-prev]', gallery), next = $('[data-gallery-next]', gallery);
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    var main = $('.gallery__main', gallery), sx = null, sy = null, moved = false;
    if (main && slides.length > 1) {
      main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; moved = false; }, { passive: true });
      main.addEventListener('touchmove', function (e) { if (sx !== null && Math.abs(e.touches[0].clientX - sx) > 10) moved = true; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) step(dx < 0 ? 1 : -1);
        sx = null;
      });
    }
    $$('[data-zoom-open]', gallery).forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (moved) { moved = false; return; }
        e.preventDefault();
        var srcs = $$('[data-zoom-open]', gallery).map(function (b) { return b.getAttribute('data-zoom-src'); });
        Lightbox.open(srcs, current());
      });
    });
    return show;
  }

  /* ---------- Date de livraison estimée ---------- */
  function initDelivery(root) {
    $$('[data-delivery]', root).forEach(function (el) {
      var min = Math.max(1, parseInt(el.dataset.min, 10) || 1), max = Math.max(min, parseInt(el.dataset.max, 10) || min);
      function addDays(n) { var d = new Date(), added = 0; while (added < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) added++; } return d; }
      try {
        var f = new Intl.DateTimeFormat('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
        var txt = $('[data-delivery-text]', el);
        if (txt) txt.innerHTML = 'Livraison estimée entre le <strong>' + f.format(addDays(min)) + '</strong> et le <strong>' + f.format(addDays(max)) + '</strong>';
      } catch (err) { /* garde le texte par défaut */ }
    });
  }

  /* ---------- Lire la suite ---------- */
  function initClamp(root) {
    $$('[data-clamp]', root).forEach(function (el) {
      function check() {
        if (el.dataset.clampDone || el.offsetParent === null) return;
        el.dataset.clampDone = '1';
        if (el.scrollHeight <= 360) return;
        el.classList.add('is-clamped');
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'read-more'; b.textContent = 'Lire la suite';
        b.addEventListener('click', function () {
          var open = el.classList.toggle('is-clamped');
          b.textContent = open ? 'Lire la suite' : 'Réduire';
        });
        el.parentNode.insertBefore(b, el.nextSibling);
      }
      check();
      var det = el.closest('details');
      if (det) det.addEventListener('toggle', check);
    });
  }

  /* ---------- Produit ---------- */
  function initProduct(root) {
    if (!once(root, 'productInit')) return;
    var gallery = $('[data-gallery]', root);
    var showMedia = gallery ? initGallery(gallery) : function () {};
    var variants = [];
    try { variants = JSON.parse(($('[data-variants-json]', root) || {}).textContent || '[]'); } catch (e) { variants = []; }
    var idInput = $('[data-variant-id]', root);
    var fieldsets = $$('[data-option-position]', root);

    function update() {
      var opts = fieldsets.map(function (fs) {
        var checked = $('input:checked', fs);
        var label = $('[data-option-selected]', fs);
        if (checked && label) label.textContent = checked.getAttribute('data-label') || checked.value;
        return checked ? checked.value : null;
      });
      var positions = fieldsets.map(function (fs) { return parseInt(fs.getAttribute('data-option-position'), 10); });
      var variant = variants.filter(function (v) { return positions.every(function (pos, k) { return v.options[pos] === opts[k]; }); })[0];

      $$('[data-add-button]', root).forEach(function (btn) {
        var addLabel = btn.getAttribute('data-label-add') || 'Ajouter au panier';
        if (!variant) { btn.disabled = true; btn.textContent = 'Indisponible'; }
        else if (!variant.available) { btn.disabled = true; btn.textContent = 'Épuisé'; }
        else { btn.disabled = false; btn.textContent = addLabel; }
      });
      $$('[data-stock]', root).forEach(function (el) { el.hidden = !(variant && variant.available); });
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      $$('[data-price]', root).forEach(function (el) { el.innerHTML = variant.price; el.classList.toggle('price--sale', !!variant.compare); });
      $$('[data-compare-price]', root).forEach(function (el) { if (variant.compare) { el.innerHTML = variant.compare; el.hidden = false; } else { el.hidden = true; } });
      $$('[data-sale-badge]', root).forEach(function (el) { if (variant.save) { el.textContent = '−' + variant.save + ' %'; el.hidden = false; } else { el.hidden = true; } });
      if (variant.media) showMedia(variant.media);
      if (root.getAttribute('data-update-url') === 'true' && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    root.addEventListener('change', function (e) { if (e.target && e.target.hasAttribute('data-option-input')) update(); });

    $$('[data-qty-step]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = $('input', btn.parentElement); if (!input) return;
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-qty-step'), 10));
      });
    });

    var sticky = $('[data-sticky-atc]', root), mainBuy = $('[data-main-buy]', root);
    if (sticky && mainBuy && 'IntersectionObserver' in window) {
      document.body.classList.add('has-sticky-atc');
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var visible = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', visible);
        if (visible) sticky.removeAttribute('inert'); else sticky.setAttribute('inert', '');
      }).observe(mainBuy);
    }
    initDelivery(root);
    initClamp(root);
  }

  /* ---------- Collections : filtres, tri, chargement progressif ---------- */
  function initCollection(root) {
    if (!once(root, 'collectionInit')) return;
    var id = root.getAttribute('data-section-id');
    var form = $('[data-filter-form]', root);
    if (!form || !window.fetch) return;
    var dialog = form.closest('dialog');

    function urlFromForm() {
      var p = new URLSearchParams();
      new FormData(form).forEach(function (v, k) { if (v !== '') p.append(k, v); });
      var q = p.toString();
      return window.location.pathname + (q ? '?' + q : '');
    }

    var pending = null;
    function load(url) {
      root.classList.add('is-loading');
      var openGroups = $$('[data-filter-groups] details', root).map(function (d) { return d.open; });
      var req = fetch(withSection(url, id), { credentials: 'same-origin' }).then(function (r) { return r.text(); });
      pending = req;
      req.then(function (text) {
        if (pending !== req) return;
        var doc = parseHTML(text);
        ['[data-results]', '[data-active-filters]', '[data-filter-groups]'].forEach(function (sel) {
          var a = $(sel, root), b = doc.querySelector(sel);
          if (a && b) a.innerHTML = b.innerHTML;
        });
        ['[data-count]', '[data-results-count]'].forEach(function (sel) {
          var a = $(sel, root), b = doc.querySelector(sel);
          if (a && b) a.textContent = b.textContent;
        });
        var fa = $('[data-filter-count]', root), fb = doc.querySelector('[data-filter-count]');
        if (fa && fb) { fa.textContent = fb.textContent; fa.hidden = fb.hasAttribute('hidden'); }
        var sa = $('[data-sort]', root), sb = doc.querySelector('[data-sort]');
        if (sa && sb) sa.value = sb.value;
        $$('[data-filter-groups] details', root).forEach(function (d, k) { if (openGroups[k]) d.open = true; });
        window.history.replaceState({}, '', url);
        reveal(root);
      }).catch(function () { window.location.href = url; })
        .finally(function () { if (pending === req) root.classList.remove('is-loading'); });
    }

    var delayed = debounce(function () { load(urlFromForm()); }, 650);
    form.addEventListener('change', function (e) {
      if (e.target.hasAttribute('data-price-input')) delayed(); else load(urlFromForm());
    });
    form.addEventListener('input', function (e) { if (e.target.hasAttribute('data-price-input')) delayed(); });
    form.addEventListener('submit', function (e) { e.preventDefault(); load(urlFromForm()); Dialog.close(dialog); });
    var sort = $('[data-sort]', root);
    if (sort) sort.addEventListener('change', function () { load(urlFromForm()); });

    root.addEventListener('click', function (e) {
      var a = e.target.closest('a[data-ajax-link]');
      if (a) { e.preventDefault(); load(a.getAttribute('href')); return; }
      var more = e.target.closest('[data-load-more-btn]');
      if (more) {
        e.preventDefault();
        more.setAttribute('aria-busy', 'true');
        fetch(withSection(more.getAttribute('href'), id), { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (text) {
            var doc = parseHTML(text);
            var grid = $('[data-grid]', root), items = doc.querySelectorAll('[data-grid] > li');
            Array.prototype.forEach.call(items, function (li) { grid.appendChild(li); });
            var box = $('[data-load-more]', root), fresh = doc.querySelector('[data-load-more]');
            if (box) { if (fresh) box.replaceWith(fresh); else box.remove(); }
            reveal(root);
          })
          .catch(function () { window.location.href = more.getAttribute('href'); });
      }
    });
  }

  /* ---------- Carrousels ---------- */
  function initSliders(root) {
    $$('[data-slider-arrows]', root).forEach(function (arrows) {
      if (!once(arrows, 'init')) return;
      var track = document.getElementById(arrows.getAttribute('data-slider-arrows'));
      if (!track) return;
      var prev = $('[data-slider-prev]', arrows), next = $('[data-slider-next]', arrows);
      function state() {
        prev.disabled = track.scrollLeft < 8;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
        arrows.hidden = track.scrollWidth <= track.clientWidth + 8;
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth * 0.85, behavior: reduceMotion ? 'auto' : 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth * 0.85, behavior: reduceMotion ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', debounce(state, 60), { passive: true });
      window.addEventListener('resize', debounce(state, 120));
      state();
    });
  }

  /* ---------- Recommandations produit ---------- */
  function initRecommendations(root) {
    $$('[data-recommendations]', root).forEach(function (el) {
      if (!once(el, 'init')) return;
      var url = el.getAttribute('data-url');
      if (!url || !window.fetch) return;
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (text) {
          if (!text) return;
          var fresh = parseHTML(text).querySelector('[data-recommendations]');
          if (fresh && fresh.querySelector('[data-grid] > li')) { el.innerHTML = fresh.innerHTML; reveal(el); }
        })
        .catch(function () {});
    });
  }

  /* ---------- Vidéo de la bannière ---------- */
  function initHeroVideos(root) {
    var wraps = $$('[data-hero-video]', root);
    if (!wraps.length) return;
    function sync() {
      wraps.forEach(function (wrap) {
        var v = $('video', wrap);
        if (!v) return;
        v.muted = true; v.setAttribute('playsinline', ''); v.removeAttribute('controls');
        if (wrap.offsetParent !== null && !reduceMotion) {
          v.preload = 'auto';
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else { v.pause(); }
      });
    }
    sync();
    var mq = window.matchMedia('(max-width: 749px)');
    if (mq.addEventListener) mq.addEventListener('change', sync);
  }

  /* ---------- Page panier ---------- */
  function initCartPage() {
    var form = document.getElementById('cart-form');
    if (!form) return;
    form.addEventListener('change', function (e) {
      if (e.target && e.target.hasAttribute('data-cart-qty')) {
        var hidden = document.createElement('input');
        hidden.type = 'hidden'; hidden.name = 'update'; hidden.value = '1';
        form.appendChild(hidden); form.submit();
      }
    });
  }

  /* ---------- Démarrage ---------- */
  function initSections(root) {
    initAnnouncement(root);
    $$('[data-product]', root).forEach(initProduct);
    $$('[data-collection]', root).forEach(initCollection);
    initSliders(root);
    initRecommendations(root);
    initHeroVideos(root);
    $$('dialog', root).forEach(bindDialog);
    reveal(root);
  }

  function init() {
    initDialogs();
    initHeader();
    initCart();
    initQuickView();
    initSearch();
    initLightbox();
    initCartPage();
    initSections(document);
    document.addEventListener('shopify:section:load', function (e) { initSections(e.target); if (e.target.querySelector('[data-header]')) initHeader(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
